import { InjectionToken, Provider } from '@angular/core';
import { MarkedExtension } from 'marked';
import { MARKED_EXTENSIONS, MARKED_OPTIONS, MarkdownModuleConfig, provideMarkdown } from 'ngx-markdown';
import { createMarkedOptions } from './base-marked-config';
import { mathExtensions } from './math-escape-marked-extension';

export const MARKDOWN_VIEWER = new InjectionToken<boolean>('markdown');

export function provideMarkdownViewer(
  markedOptionsProvider?: MarkdownModuleConfig['markedOptions'],
  extensions: MarkedExtension['extensions'] = mathExtensions,
): Provider[] {
  const markedOptions =
    markedOptionsProvider ??
    ({
      provide: MARKED_OPTIONS,
      useFactory: () => createMarkedOptions(),
    } as const);

  return [
    {
      provide: MARKDOWN_VIEWER,
      useValue: true,
    },
    provideMarkdown({
      markedOptions,
      markedExtensions: [
        {
          provide: MARKED_EXTENSIONS,
          useFactory: () => ({
            extensions,
          }),
          multi: true,
        },
      ],
    }),
  ];
}
